/**
 * Передача вибраної події на сторінку ДЗ.
 *
 * Сторінка /homework читає ці ключі з localStorage. Раніше запис і очистка були
 * розкидані по чотирьох місцях (Schedule, ScheduleEvent, EventModalItem, EventModal),
 * тому логіка зведена сюди.
 */
const KEYS = ['event', 'eventId', 'realHomeworkId'];

export const rememberHomeworkEvent = (event) => {
  try {
    localStorage.setItem('event', JSON.stringify(event));
    localStorage.setItem('eventId', JSON.stringify(event?.id ?? null));
    localStorage.setItem('realHomeworkId', JSON.stringify(event?.homework_id ?? null));
  } catch (e) {
    // Приватний режим Safari забороняє запис — перехід на ДЗ усе одно має відбутись.
    console.error('Не вдалося зберегти подію для ДЗ', e);
  }
};

export const forgetHomeworkEvent = () => {
  try {
    KEYS.forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    console.error('Не вдалося очистити подію ДЗ', e);
  }
};

export const readHomeworkEvent = () => {
  try {
    const raw = localStorage.getItem('event');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    console.error('Не вдалося прочитати подію ДЗ', e);
    return null;
  }
};
